/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ComplexRuleType {
    AT_MOST_ONE = 'AtMostOne',
    EXACTLY_ONE = 'ExactlyOne',
    INPAYMENT_FORM_CREDITOR_NUMBER = 'InpaymentFormCreditorNumber',
    OCR_NUMBER_VALIDATOR = 'OcrNumberValidator',
}